import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LessonState {
    lessonProgressData: any;
    lessonData: any;
    currentFragmentIndex: number;
    setCurrentFragment: (fragmentNum: number) => void;
    setLessonProgressData: (lessonProgress: any) => void;
    setLessonData: (lesson: any) => void;
}

export const useLessonStore = create<LessonState>()(
    persist(
        (set) => ({
            lessonProgressData: null,
            lessonData: null,
            currentFragmentIndex: 0,
            setCurrentFragment: (fragmentIndex: number) => set({
                currentFragmentIndex: fragmentIndex
            }),
            setLessonProgressData: (lessonProgress: any) => set({
                lessonProgressData: lessonProgress
            }),
            setLessonData: (lesson: any) => set({
                lessonData: lesson
            })
        }),
        {
            name: 'auth-storage',
            version: 1,
            partialize: (state) => ({ }),
        }
    )
);
